import { NgModule } from '@angular/core';
import { CharactersEntitiesState } from './state/characters.entities.state';
import { NgxsModule } from '@ngxs/store';

@NgModule({
  imports: [NgxsModule.forFeature([CharactersEntitiesState])],
})
export class CharactersModule {}
